import React, { useEffect } from 'react';

import { MDText } from 'i18n-react';

import useLoadExternalScripts from 'Utilities/hooks/useLoadScripts';
import { HELP_URL, MENTION_ME_REFER_BASE_URL } from 'Utilities/urls';

import { Content } from 'LegacySBCRA/Content/Content';
import { LoadingArrow } from 'Storybook/components/local/LoadingArrow/LoadingArrow';

import PageHeader from '../../common/PageHeader/PageHeader';

import ReferTexts from './ReferTexts.json';

import styles from './Refer.scss';

const LocalT = new MDText(ReferTexts);

// https://isotropic.co/how-to-fix-the-property-does-not-exist-on-type-window-error-in-typescript/
declare global {
  interface Window {
    MentionMeFiredTags: any;
  }
}

const Refer = () => {
  const scripts = [`${MENTION_ME_REFER_BASE_URL}?situation=landingpage&locale=en_GB`];
  const { handleExternalScript, loading } = useLoadExternalScripts();

  useEffect(() => {
    const id = 'mentionMeReferPage';
    handleExternalScript({ id, scripts });

    // https://help.mention-me.com/hc/en-gb/articles/7541078561181-Single-page-application-SPA-Referee-tag-implementation
    return () => {
      if (window?.MentionMeFiredTags?.embedlandingpage) {
        delete window?.MentionMeFiredTags?.embedlandingpage;
      }
      document?.getElementById(id)?.remove();
    };
  }, []);

  return (
    <>
      {
        (
          <div className={styles.component}>
            <PageHeader title={LocalT.translate('title') as string} />
            <Content center className={styles.contentWrapper}>
              { loading && <div className={styles.loaderWrapper}><LoadingArrow /></div> }
              <div className={styles.wrapper} data-testid="mmWrapper" id="mmWrapper"></div>
            </Content>
            <div className={styles.faq}>
              <Content center>
                <p>
                  {LocalT.translate('faq.text', {
                    link: (
                      <a
                        className="mw-link mw-link-blue"
                        href={`${HELP_URL}/articles/7745221365788-How-does-Motorway-s-refer-a-friend-scheme-work`}
                        rel="noopener noreferrer"
                        target="_blank" >{LocalT.translate('faq.link')}
                      </a>
                    ),
                  })}
                </p>
              </Content>
            </div>
          </div>
        )
      }
    </>
  );
};
export default Refer;
